import Vue from 'vue';
import SearchBar from "./SearchBar"

// Application files
if (document.getElementById("search-bar")) {
    new Vue({
        el: "#search-bar",
        components: {
            SearchBar
        },
    });
}
